module.exports = __webpack_public_path__ + "static/media/drakos1.187eaa60.jpg";